module.exports = __webpack_public_path__ + "static/media/san_francisco.f15045b0.jpg";